import { TTableStructure, TTableStructureFilter } from 'ui/EasTable/types';
import { TAvailableReport, TReportType } from 'redux/reducers/reports/types';
import { DEFAULT_REPORT_FILE_EXTENSION, REPORT_TYPE_FILTER_SELECTOR } from './constants';
import { TAvailableReportRow } from './types';

/** The date part of an ISO date-time, e.g. "2025-01-31T00:00:00" -> "2025-01-31". */
const toDate = (value: string): string => value.split('T')[0];

export const mapReportToRow = (report: TAvailableReport): TAvailableReportRow => ({
	...report,
	period: `${toDate(report.periodStart)} - ${toDate(report.periodEnd)}`,
});

/** The Report Type column offers the report types the API knows about. */
export const withReportTypeOptions = (
	structure: TTableStructure<keyof TAvailableReportRow, TAvailableReportRow>[],
	reportTypes: TReportType[] | null,
): TTableStructure<keyof TAvailableReportRow, TAvailableReportRow>[] => {
	const options: TTableStructureFilter = (reportTypes ?? []).map((reportType): [string, string] => [
		String(reportType.id),
		reportType.name ?? String(reportType.id),
	]);

	return structure.map((column) =>
		column.selector === REPORT_TYPE_FILTER_SELECTOR ? { ...column, filter: options } : column,
	);
};

export const getReportFileName = (report: TAvailableReportRow): string => {
	const baseName = `${report.reportTypeName ?? 'report'}_${report.period}`
		.replace(/[^\w.-]+/g, '_')
		.replace(/_+/g, '_');
	return `${baseName}.${DEFAULT_REPORT_FILE_EXTENSION}`;
};
